import { useNotificationsContext } from "common/context/NotificationsProvider"
import "../style.scss"

const NotificationsDatesLine = () => {
  // @ts-expect-error TS(2339): Property 'allNotifications' does not exist on type...
  const { allNotifications } = useNotificationsContext()

  return (
    <>
      {allNotifications.totalCount > 0 && (
        <div className='notifications-dates-line' />
      )}
    </>
  )
}

export default NotificationsDatesLine
